import React from 'react';

import Summary from 'components/Summary/Summary'
import PageVerticalContentStepper from 'components/PageVerticalContentStepper/PageVerticalContentStepper'
import { getAppLinkBasedOnOS } from 'pages/MObywatelIdentityPage/helpers'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import useClientPeselReservedPageLogic from './hooks/useClientPeselReservedPageLogic'
import { IClientPeselReservedPageContentProps } from './ClientPeselReservedPageProps'

import './ClientPeselReservedPageStyles.scss'


const ClientPeselReservedPageContent = (props: IClientPeselReservedPageContentProps): JSX.Element => {

   const { clientPeselReservedTextContents } = props

   return (
      <section className='client-pesel-reserved-page-outer-section-wrapper'>
         <h1 className='client-pesel-reserved-page-header'>{clientPeselReservedTextContents('clientPeselReservedPage.header')}</h1>
         <div className='client-pesel-reserved-page-description'>
            <p dangerouslySetInnerHTML={{__html: clientPeselReservedTextContents('clientPeselReservedPage.description')}} />
         </div>
         <PageVerticalContentStepper
            StepOneContentElement={() => (
            <>
               Zaloguj się do aplikacji
               <b><a href={getAppLinkBasedOnOS()} target='_blank' rel="noreferrer">&nbsp;mObywatel &nbsp;</a></b>
               lub na stronę<b><a href='https://mobywatel.gov.pl'  target='_blank' rel="noreferrer">&nbsp;mobywatel.gov.pl&nbsp;</a></b>
               i cofnij tymczasowo <b>zastrzeżenie PESEL.</b> 
            </>
            )}
            StepTwoContentElement={() => (<span dangerouslySetInnerHTML={{__html: clientPeselReservedTextContents('clientPeselReservedPage.stepperStage2')}} />)}
         />
         <Button 
            isLoading={props.isButtonLoading} 
            disabled={props.isButtonBlocked} 
            uiButtonType={AppButtonTypes.PRIMARY} 
            buttonContent={clientPeselReservedTextContents('buttons.check')} 
            className='client-pesel-reserved-page-submit-button page-main-button-submission-button' 
            onClick={() => props.handleOnButtonCheckClick()}
         />
         {
            props.currentClientPeselReservedErrorText ? 
            <p className='client-pesel-reserved-page-error-message-text'>{props.currentClientPeselReservedErrorText}</p> : 
            <p className='client-pesel-reserved-page-error-message-text' />
         }
         <ButtonCancelApplication className='client-pesel-reserved-page-cancel-application-button'/>
      </section>
   )
}


/**
 * Komponent obsługujący stronę "Numer Pesel Zarezerwowany"
*/
const ClientPeselReservedPage = (): JSX.Element => {

   const { 
      handleOnButtonCheckClick, 
      isButtonBlocked, 
      isButtonLoading, 
      currentClientPeselReservedErrorText, 
      clientPeselReservedTextContents 
   } = useClientPeselReservedPageLogic()

   return (
      <div className='client-pesel-reserved-page-main-wrapper'>
         <ClientPeselReservedPageContent 
            handleOnButtonCheckClick={handleOnButtonCheckClick} 
            isButtonBlocked={isButtonBlocked} 
            isButtonLoading={isButtonLoading}
            currentClientPeselReservedErrorText={currentClientPeselReservedErrorText}
            clientPeselReservedTextContents={clientPeselReservedTextContents}
         />
         <Summary />
      </div>
   )
}

export default ClientPeselReservedPage